module.exports = __webpack_public_path__ + "public/img/使用指南 2.255a79bf.png";